import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { SiteArea } from 'src/app/models/site-area.model';
import { Site } from 'src/app/models/site.model';
import { SelectAreaDialogComponent } from './select-area.dialog';

@Component({
  selector: 'app-select-area-button',
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations
  template: `
    <ion-button shape="round" [color]="color()" size="small" (click)="select()">
      @if (text()) {
        {{ text() | translate }}
      } @else {
        @if (selectedItem()?.length > 0) {
          @for (area of selectedItem(); track area.guid; let last = $last) {
              <div>{{ area.name }}@if (!last) {,&nbsp;}</div>
            }
        } @else {
          @if (title()) {
            {{ title() | translate }}
          } @else {
          {{ 'calendar.site.area' | translate }}
          }
        }
      }
    </ion-button>
  `,
  styles: `ion-button { --padding-bottom: 12px; --padding-top: 12px; margin: 0 2px; }`,
  imports: [
    AppCommonModule,
    CommonModule,

  ],
})
export class SelectAreaButtonComponent {
  private modalCtrl = inject(ModalController);

  color = input('light');
  selectedItem = input<SiteArea[]>(null);
  site = input.required<Site>();
  text = input<string>();
  title = input<string>();
  onlyResidences = input(false);
  multiple = input(false);

  selected = output<SiteArea[]>();

  select() {
    const clearButton = this.selectedItem() != null;
    this.modalCtrl.create({
      component: SelectAreaDialogComponent,
      componentProps: { site: this.site(), clearButton, onlyResidences: this.onlyResidences(), multiple: this.multiple() },
    }).then((m) => {
      m.present();

      m.onDidDismiss<{ id?: string; siteArea?: SiteArea }[]>().then((data) => {
        if (data.data) {
          const areas = data.data.map((it) => it.siteArea);
          this.selected.emit(areas);
        }
      });
    });
  }
}
